/* eslint-disable */
"use strict";

var config, service, ecommerce;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  ecommerce = config.VUE_APP_MOL_S_ECOMMERCE
}

(async () => {
  await leggiImpostazioni();
})();

async function getInfoProdotto(idProdotto, raw) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    idProdotto,
    raw,
  };
  try {
    const response = await fetch(`${service}/${ecommerce}/getInfoProdotto`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function mapInfoProdotto(prodotto) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    prodotto,
  };
  try {
    const response = await fetch(`${service}/${ecommerce}/mapInfoProdotto`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getElencoProdotti(opzioni) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    opzioni,
  };
  try {
    const response = await fetch(`${service}/${ecommerce}/getElencoProdotti`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function getTotaleProdotti() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${ecommerce}/getTotaleProdotti`);
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function aggiornaGiacenzaProdotto(
  prodotto,
  valore,
  gestioneSeparataStockVarianti
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    prodotto,
    valore,
    gestioneSeparataStockVarianti,
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/aggiornaGiacenzaProdotto`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function aggiornaPrezziProdotto(
  prodotto,
  prezzi,
  gestioneSeparataStockVarianti
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    prodotto,
    prezzi,
    gestioneSeparataStockVarianti,
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/aggiornaPrezziProdotto`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function aggiornaDescrizioniProdotto(
  prodotto,
  descrizioni,
  gestioneSeparataStockVarianti
) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    prodotto,
    descrizioni,
    gestioneSeparataStockVarianti,
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/aggiornaDescrizioniProdotto`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaProdottoBase(impostazioni, prodotto, variante1, variante2) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni, prodotto, variante1, variante2
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/creaProdottoBase`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function creaProdottoVariante(impostazioni, idProdottoBase, prodotto, variante1, variante2) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    impostazioni, idProdottoBase, prodotto, variante1, variante2
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/creaProdottoVariante`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function aggiornaGiacenzaWebSingola(item, giacenza) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    item,
    giacenza,
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/aggiornaGiacenzaWebSingola`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function aggiornaGiacenze() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(`${service}/${ecommerce}/aggiornaGiacenze`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function scaricaTuttiProdotti() {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const response = await fetch(
      `${service}/${ecommerce}/scaricaTuttiProdotti`
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function sincronizzaVariazioni(aggiornaDb) {
  if (!config || !service) {
    await getConfigFile();
  }
  const data = {
    aggiornaDb,
  };
  try {
    const response = await fetch(
      `${service}/${ecommerce}/sincronizzaVariazioni`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

export default {
  getInfoProdotto,
  getElencoProdotti,
  mapInfoProdotto,
  getTotaleProdotti,
  aggiornaGiacenzaProdotto,
  aggiornaPrezziProdotto,
  aggiornaDescrizioniProdotto,
  aggiornaGiacenze,
  sincronizzaVariazioni,
  creaProdottoBase,
  creaProdottoVariante,
  aggiornaGiacenzaWebSingola,
  scaricaTuttiProdotti,
};
